var render = function render(_c,_vm){return _vm._m(0)
}
var staticRenderFns = [function (_c,_vm){return _c('section',{staticClass:"noData"},[_c('img',{staticClass:"block mx-auto",attrs:{"src":require("@/assets/img/global/common/icon-nodata.png")}}),_vm._v(" "),_c('p',{staticClass:"noDataText"},[_vm._v("暂无数据...")])])
}]

export { render, staticRenderFns }